import { Context, CustomQuery } from '@vue-storefront/core';
import { ApiResult } from '../../types';
import { getListDetail } from '../../getter';
// 用户可用折扣列表
export default async function BenefitCodeOperates(context: Context, params: CustomQuery): Promise<ApiResult> {
  const url = new URL('/mall/benefit_code/batch/operate', context.config.api.url);
  const { data: res } = await context.client.post(url.href, params);
  if (res.data && res.data.data && res.data.data.promo_details) {
    res.data.data.promo_details.forEach(p => {
      try {
        p.gift_goods = p.gift_goods ? getListDetail(p.gift_goods) : p.gift_goods;
      } catch (err) {
        console.error('转换商品类型错误', err);
      }
    });
  }
  return res;
}
